import { render, staticRenderFns } from "./LB.vue?vue&type=template&id=6e9715c3&"
import script from "./LB.vue?vue&type=script&lang=js&"
export * from "./LB.vue?vue&type=script&lang=js&"
import style0 from "./LB.vue?vue&type=style&index=0&id=6e9715c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports